var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CRow',[_c('CCol',{attrs:{"sm":"12"}},[_c('InvoicesView',{attrs:{"id":_vm.id,"is_new":_vm.id > 0 && _vm.option != 'clone' ? false : true,"is_clone":_vm.option == 'clone' ? true : false}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }